import { getIdSports } from '../../../common/data/sports';
import { getModel } from '../../../services/api2.service';
import { IClubReturn, IListClubReturn } from '../interfaces/club';

/**
 * Get all clubs
 */
export const getAllClubs = async (page: number, limit: number, search: string): Promise<IListClubReturn> => {
    const urlModel = `clubs?limit=${limit}&page=${page}&search=${search}`;
    const data = await getModel(urlModel);
    return data;
};

/**
 * Get club by sport name
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getClubBySport = async (query): Promise<IClubReturn> => {
    if (query) {
        const sportId = getIdSports(query.sport)
        let filter = '';
        if (query && sportId) {
            filter = `?&sportId=${sportId ? sportId : ''}&formatId=${
                query.format ? query.format : ''
            }&regionId=${query.region ? query.region : ''}&countyId=${query.commune ? query.commune : ''}`;
        }
        const urlModel = `clubs${filter}`;
        const data = await getModel(urlModel);
        return data;
    }
   
};

/**
 * Get club by sport name
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getClubBySportSelect = async ({ query }): Promise<IClubReturn> => {
    if (query) {
        const sportId = getIdSports(query.sport)
        let filter = '';
        if (query && sportId) {
            filter = `?&sportId=${sportId ? sportId : ''}&formatId=${
                query.format ? query.format : ''
            }&regionId=${query.region ? query.region : ''}&countyId=${query.commune ? query.commune : ''}`;
        }
        const urlModel = `clubs${filter}`;
        const data = await getModel(urlModel);
        return data;
    }
   
};

/**
 * Get club by ID
 */
export const getClubById = async (id: string): Promise<IClubReturn> => {
    const urlModel = `clubs/${id}`;
    const data = await getModel(urlModel);
    return data;
};
